// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type {
  AdminLevelsFindAllData,
  AdminLevelsFindAllResponses,
  AdminLevelsFindOneData,
  AdminLevelsFindOneResponses,
  AuthenticationGetUserData,
  AuthenticationGetUserResponses,
  AuthenticationGetWfsAuthorizationData,
  AuthenticationGetWfsAuthorizationResponses,
  AuthenticationLoginData,
  AuthenticationLoginResponses,
  AuthenticationLogoutData,
  AuthenticationLogoutResponses,
  AuthenticationSamlAssertionConsumerData,
  AuthenticationSamlAssertionConsumerResponses,
  AuthenticationSamlLogoutData,
  AuthenticationSamlLogoutResponses,
  AuthenticationSamlMetadataData,
  AuthenticationSamlMetadataResponses,
  AuthenticationSamlSingleLogoutData,
  AuthenticationSamlSingleLogoutResponses,
  BemasImportImportOrganizationsData,
  BemasImportImportOrganizationsResponses,
  BemasImportImportPoliceData,
  BemasImportImportPoliceResponses,
  CaslGetRulesData,
  CaslGetRulesResponses,
  ExternalSignsImportData,
  ExternalSignsImportResponses,
  ExternalSignsUploadData,
  ExternalSignsUploadResponses,
  GeocoderGeocodeData,
  GeocoderGeocodeResponses,
  GeocoderReverseData,
  GeocoderReverseResponses,
  HealthCheckData,
  HealthCheckErrors,
  HealthCheckResponses,
  OpenLrImportData,
  OpenLrImportResponses,
  OrganizationsCreateData,
  OrganizationsCreateOrganizationAdminLevelData,
  OrganizationsCreateOrganizationAdminLevelResponses,
  OrganizationsCreateOrganizationStakeholderData,
  OrganizationsCreateOrganizationStakeholderResponses,
  OrganizationsCreateOrganizationUserData,
  OrganizationsCreateOrganizationUserResponses,
  OrganizationsCreateResponses,
  OrganizationsFindAllData,
  OrganizationsFindAllResponses,
  OrganizationsFindOneData,
  OrganizationsFindOneOrganizationAdminLevelData,
  OrganizationsFindOneOrganizationAdminLevelResponses,
  OrganizationsFindOneOrganizationUserData,
  OrganizationsFindOneOrganizationUserResponses,
  OrganizationsFindOneResponses,
  OrganizationsFindOrganizationStakeholderData,
  OrganizationsFindOrganizationStakeholderResponses,
  OrganizationsRemoveOrganizationAdminLevelData,
  OrganizationsRemoveOrganizationAdminLevelResponses,
  OrganizationsRemoveOrganizationStakeholderData,
  OrganizationsRemoveOrganizationStakeholderResponses,
  OrganizationsRemoveOrganizationUserData,
  OrganizationsRemoveOrganizationUserResponses,
  OrganizationsUpdateData,
  OrganizationsUpdateOrganizationAdminLevelData,
  OrganizationsUpdateOrganizationAdminLevelResponses,
  OrganizationsUpdateOrganizationUserData,
  OrganizationsUpdateOrganizationUserResponses,
  OrganizationsUpdateResponses,
  ProcessesAddSignData,
  ProcessesAddSignResponses,
  ProcessesCancelProcessData,
  ProcessesCancelProcessResponses,
  ProcessesCreateData,
  ProcessesCreateExaminationData,
  ProcessesCreateExaminationResponses,
  ProcessesCreateResponses,
  ProcessesFinalizeProcessData,
  ProcessesFinalizeProcessResponses,
  ProcessesFindAllData,
  ProcessesFindAllFilesData,
  ProcessesFindAllFilesResponses,
  ProcessesFindAllNotificationsData,
  ProcessesFindAllNotificationsResponses,
  ProcessesFindAllResponses,
  ProcessesFindOneData,
  ProcessesFindOneExaminationPublicData,
  ProcessesFindOneExaminationPublicResponses,
  ProcessesFindOneExecutionPublicData,
  ProcessesFindOneExecutionPublicResponses,
  ProcessesFindOneFileData,
  ProcessesFindOneFileResponses,
  ProcessesFindOneResponses,
  ProcessesGeneratePdfData,
  ProcessesGeneratePdfResponses,
  ProcessesRemoveData,
  ProcessesRemoveExaminationData,
  ProcessesRemoveExaminationResponses,
  ProcessesRemoveFileData,
  ProcessesRemoveFileResponses,
  ProcessesRemoveResponses,
  ProcessesRemoveSignData,
  ProcessesRemoveSignResponses,
  ProcessesUpdateData,
  ProcessesUpdateExaminationData,
  ProcessesUpdateExaminationPublicData,
  ProcessesUpdateExaminationPublicResponses,
  ProcessesUpdateExaminationResponses,
  ProcessesUpdateExecutionPublicData,
  ProcessesUpdateExecutionPublicResponses,
  ProcessesUpdateExternalData,
  ProcessesUpdateExternalResponses,
  ProcessesUpdateResponses,
  ProcessesUpdateStepDecisionData,
  ProcessesUpdateStepDecisionResponses,
  ProcessesUpdateStepDraftData,
  ProcessesUpdateStepDraftResponses,
  ProcessesUpdateStepExaminationData,
  ProcessesUpdateStepExaminationResponses,
  ProcessesUpdateStepExecutionData,
  ProcessesUpdateStepExecutionResponses,
  ProcessesUploadFileData,
  ProcessesUploadFileResponses,
  SignCodesFindAllData,
  SignCodesFindAllResponses,
  SignCodesFindOneData,
  SignCodesFindOneResponses,
  SignGroupsCreateData,
  SignGroupsCreateResponses,
  SignGroupsFindOneData,
  SignGroupsFindOneResponses,
  SignGroupsRemoveData,
  SignGroupsRemoveResponses,
  SignGroupsUpdateData,
  SignGroupsUpdateOpenLrData,
  SignGroupsUpdateOpenLrResponses,
  SignGroupsUpdateResponses,
  SignImagesFindAllData,
  SignImagesFindAllResponses,
  SignImagesFindOneData,
  SignImagesFindOneResponses,
  SignImagesRemoveData,
  SignImagesRemoveResponses,
  SignImagesUploadData,
  SignImagesUploadResponses,
  SignsCreateData,
  SignsCreateResponses,
  SignsCreateStatusData,
  SignsCreateStatusResponses,
  SignsFindAllData,
  SignsFindAllProcessSuggestionData,
  SignsFindAllProcessSuggestionResponses,
  SignsFindAllResponses,
  SignsFindOneData,
  SignsFindOneResponses,
  SignsRemoveData,
  SignsRemoveResponses,
  SignsUpdateData,
  SignsUpdateResponses,
  SignSupportsCreateData,
  SignSupportsCreateResponses,
  SignSupportsFindOneData,
  SignSupportsFindOneResponses,
  SignSupportsRemoveData,
  SignSupportsRemoveResponses,
  SignSupportsUpdateData,
  SignSupportsUpdateResponses,
  UsersCreateData,
  UsersCreateResponses,
  UsersFindAllData,
  UsersFindAllResponses,
  UsersFindOneData,
  UsersFindOneResponses,
  UsersRemoveData,
  UsersRemoveResponses,
  UsersUpdateData,
  UsersUpdateResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const backendApiHealthCheck = <ThrowOnError extends boolean = false>(
  options?: Options<HealthCheckData, ThrowOnError>,
) =>
  (options?.client ?? client).get<HealthCheckResponses, HealthCheckErrors, ThrowOnError>({
    url: '/api/health',
    ...options,
  });

export const backendApiAuthenticationLogin = <ThrowOnError extends boolean = false>(
  options?: Options<AuthenticationLoginData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AuthenticationLoginResponses, unknown, ThrowOnError>({
    url: '/api/authentication/login',
    ...options,
  });

export const backendApiAuthenticationSamlAssertionConsumer = <ThrowOnError extends boolean = false>(
  options?: Options<AuthenticationSamlAssertionConsumerData, ThrowOnError>,
) =>
  (options?.client ?? client).post<AuthenticationSamlAssertionConsumerResponses, unknown, ThrowOnError>({
    url: '/api/authentication/saml/assertion-consumer',
    ...options,
  });

export const backendApiAuthenticationLogout = <ThrowOnError extends boolean = false>(
  options?: Options<AuthenticationLogoutData, ThrowOnError>,
) =>
  (options?.client ?? client).post<AuthenticationLogoutResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/authentication/logout',
    ...options,
  });

export const backendApiAuthenticationSamlLogout = <ThrowOnError extends boolean = false>(
  options?: Options<AuthenticationSamlLogoutData, ThrowOnError>,
) =>
  (options?.client ?? client).post<AuthenticationSamlLogoutResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/authentication/saml-logout',
    ...options,
  });

export const backendApiAuthenticationSamlSingleLogout = <ThrowOnError extends boolean = false>(
  options?: Options<AuthenticationSamlSingleLogoutData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AuthenticationSamlSingleLogoutResponses, unknown, ThrowOnError>({
    url: '/api/authentication/saml/single-logout',
    ...options,
  });

export const backendApiAuthenticationSamlMetadata = <ThrowOnError extends boolean = false>(
  options?: Options<AuthenticationSamlMetadataData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AuthenticationSamlMetadataResponses, unknown, ThrowOnError>({
    url: '/api/authentication/saml/metadata',
    ...options,
  });

export const backendApiAuthenticationGetUser = <ThrowOnError extends boolean = false>(
  options?: Options<AuthenticationGetUserData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AuthenticationGetUserResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/authentication',
    ...options,
  });

export const backendApiAuthenticationGetWfsAuthorization = <ThrowOnError extends boolean = false>(
  options?: Options<AuthenticationGetWfsAuthorizationData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AuthenticationGetWfsAuthorizationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/authentication/wfs',
    ...options,
  });

export const backendApiCaslGetRules = <ThrowOnError extends boolean = false>(
  options?: Options<CaslGetRulesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<CaslGetRulesResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/casl',
    ...options,
  });

export const backendApiUsersFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<UsersFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<UsersFindAllResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/users',
    ...options,
  });

export const backendApiUsersCreate = <ThrowOnError extends boolean = false>(
  options: Options<UsersCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<UsersCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiUsersRemove = <ThrowOnError extends boolean = false>(
  options: Options<UsersRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<UsersRemoveResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/users/{userId}',
    ...options,
  });

export const backendApiUsersFindOne = <ThrowOnError extends boolean = false>(
  options: Options<UsersFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<UsersFindOneResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/users/{userId}',
    ...options,
  });

export const backendApiUsersUpdate = <ThrowOnError extends boolean = false>(
  options: Options<UsersUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<UsersUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/users/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiAdminLevelsFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<AdminLevelsFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<AdminLevelsFindAllResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/admin-levels',
    ...options,
  });

export const backendApiAdminLevelsFindOne = <ThrowOnError extends boolean = false>(
  options: Options<AdminLevelsFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<AdminLevelsFindOneResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/admin-levels/{adminLevelId}',
    ...options,
  });

export const backendApiGeocoderGeocode = <ThrowOnError extends boolean = false>(
  options: Options<GeocoderGeocodeData, ThrowOnError>,
) =>
  (options.client ?? client).get<GeocoderGeocodeResponses, unknown, ThrowOnError>({
    url: '/api/geocoder/geocode/{query}',
    ...options,
  });

export const backendApiGeocoderReverse = <ThrowOnError extends boolean = false>(
  options: Options<GeocoderReverseData, ThrowOnError>,
) =>
  (options.client ?? client).get<GeocoderReverseResponses, unknown, ThrowOnError>({
    url: '/api/geocoder/reverse/{longitude}/{latitude}',
    ...options,
  });

export const backendApiOrganizationsFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<OrganizationsFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<OrganizationsFindAllResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/organizations',
    ...options,
  });

export const backendApiOrganizationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<OrganizationsCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/organizations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiOrganizationsFindOne = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<OrganizationsFindOneResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/organizations/{organizationId}',
    ...options,
  });

export const backendApiOrganizationsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<OrganizationsUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/organizations/{organizationId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiOrganizationsRemoveOrganizationAdminLevel = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsRemoveOrganizationAdminLevelData, ThrowOnError>,
) =>
  (options.client ?? client).delete<OrganizationsRemoveOrganizationAdminLevelResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/organizations/{organizationId}/admin-levels/{adminLevelId}',
    ...options,
  });

export const backendApiOrganizationsFindOneOrganizationAdminLevel = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsFindOneOrganizationAdminLevelData, ThrowOnError>,
) =>
  (options.client ?? client).get<OrganizationsFindOneOrganizationAdminLevelResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/organizations/{organizationId}/admin-levels/{adminLevelId}',
    ...options,
  });

export const backendApiOrganizationsUpdateOrganizationAdminLevel = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsUpdateOrganizationAdminLevelData, ThrowOnError>,
) =>
  (options.client ?? client).patch<OrganizationsUpdateOrganizationAdminLevelResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/organizations/{organizationId}/admin-levels/{adminLevelId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiOrganizationsCreateOrganizationAdminLevel = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsCreateOrganizationAdminLevelData, ThrowOnError>,
) =>
  (options.client ?? client).post<OrganizationsCreateOrganizationAdminLevelResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/organizations/{organizationId}/admin-levels/{adminLevelId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiOrganizationsRemoveOrganizationUser = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsRemoveOrganizationUserData, ThrowOnError>,
) =>
  (options.client ?? client).delete<OrganizationsRemoveOrganizationUserResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/organizations/{organizationId}/users/{userId}',
    ...options,
  });

export const backendApiOrganizationsFindOneOrganizationUser = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsFindOneOrganizationUserData, ThrowOnError>,
) =>
  (options.client ?? client).get<OrganizationsFindOneOrganizationUserResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/organizations/{organizationId}/users/{userId}',
    ...options,
  });

export const backendApiOrganizationsUpdateOrganizationUser = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsUpdateOrganizationUserData, ThrowOnError>,
) =>
  (options.client ?? client).patch<OrganizationsUpdateOrganizationUserResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/organizations/{organizationId}/users/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiOrganizationsCreateOrganizationUser = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsCreateOrganizationUserData, ThrowOnError>,
) =>
  (options.client ?? client).post<OrganizationsCreateOrganizationUserResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/organizations/{organizationId}/users/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiOrganizationsFindOrganizationStakeholder = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsFindOrganizationStakeholderData, ThrowOnError>,
) =>
  (options.client ?? client).get<OrganizationsFindOrganizationStakeholderResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/organizations/{organizationId}/stakeholders',
    ...options,
  });

export const backendApiOrganizationsCreateOrganizationStakeholder = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsCreateOrganizationStakeholderData, ThrowOnError>,
) =>
  (options.client ?? client).post<OrganizationsCreateOrganizationStakeholderResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/organizations/{organizationId}/stakeholders',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiOrganizationsRemoveOrganizationStakeholder = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationsRemoveOrganizationStakeholderData, ThrowOnError>,
) =>
  (options.client ?? client).delete<OrganizationsRemoveOrganizationStakeholderResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/organizations/{organizationId}/stakeholders/{stakeholderId}',
    ...options,
  });

export const backendApiSignSupportsCreate = <ThrowOnError extends boolean = false>(
  options: Options<SignSupportsCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<SignSupportsCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/sign-supports',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiSignSupportsRemove = <ThrowOnError extends boolean = false>(
  options: Options<SignSupportsRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<SignSupportsRemoveResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/sign-supports/{signSupportId}',
    ...options,
  });

export const backendApiSignSupportsFindOne = <ThrowOnError extends boolean = false>(
  options: Options<SignSupportsFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<SignSupportsFindOneResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/sign-supports/{signSupportId}',
    ...options,
  });

export const backendApiSignSupportsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<SignSupportsUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<SignSupportsUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/sign-supports/{signSupportId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiSignGroupsCreate = <ThrowOnError extends boolean = false>(
  options: Options<SignGroupsCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<SignGroupsCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/sign-groups',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiSignGroupsRemove = <ThrowOnError extends boolean = false>(
  options: Options<SignGroupsRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<SignGroupsRemoveResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/sign-groups/{signGroupId}',
    ...options,
  });

export const backendApiSignGroupsFindOne = <ThrowOnError extends boolean = false>(
  options: Options<SignGroupsFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<SignGroupsFindOneResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/sign-groups/{signGroupId}',
    ...options,
  });

export const backendApiSignGroupsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<SignGroupsUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<SignGroupsUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/sign-groups/{signGroupId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiSignGroupsUpdateOpenLr = <ThrowOnError extends boolean = false>(
  options?: Options<SignGroupsUpdateOpenLrData, ThrowOnError>,
) =>
  (options?.client ?? client).post<SignGroupsUpdateOpenLrResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/sign-groups/update-open-lr',
    ...options,
  });

export const backendApiSignsFindAll = <ThrowOnError extends boolean = false>(
  options: Options<SignsFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).get<SignsFindAllResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/signs',
    ...options,
  });

export const backendApiSignsCreate = <ThrowOnError extends boolean = false>(
  options: Options<SignsCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<SignsCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/signs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiSignsFindAllProcessSuggestion = <ThrowOnError extends boolean = false>(
  options?: Options<SignsFindAllProcessSuggestionData, ThrowOnError>,
) =>
  (options?.client ?? client).get<SignsFindAllProcessSuggestionResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/signs/process-suggestion',
    ...options,
  });

export const backendApiSignsRemove = <ThrowOnError extends boolean = false>(
  options: Options<SignsRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<SignsRemoveResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/signs/{signId}',
    ...options,
  });

export const backendApiSignsFindOne = <ThrowOnError extends boolean = false>(
  options: Options<SignsFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<SignsFindOneResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/signs/{signId}',
    ...options,
  });

export const backendApiSignsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<SignsUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<SignsUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/signs/{signId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiSignsCreateStatus = <ThrowOnError extends boolean = false>(
  options: Options<SignsCreateStatusData, ThrowOnError>,
) =>
  (options.client ?? client).post<SignsCreateStatusResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/signs/{signId}/statuses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiSignCodesFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<SignCodesFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<SignCodesFindAllResponses, unknown, ThrowOnError>({
    url: '/api/sign-codes',
    ...options,
  });

export const backendApiSignCodesFindOne = <ThrowOnError extends boolean = false>(
  options: Options<SignCodesFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<SignCodesFindOneResponses, unknown, ThrowOnError>({
    url: '/api/sign-codes/{code}',
    ...options,
  });

export const backendApiBemasImportImportPolice = <ThrowOnError extends boolean = false>(
  options: Options<BemasImportImportPoliceData, ThrowOnError>,
) =>
  (options.client ?? client).post<BemasImportImportPoliceResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/bemas-import/police',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const backendApiBemasImportImportOrganizations = <ThrowOnError extends boolean = false>(
  options?: Options<BemasImportImportOrganizationsData, ThrowOnError>,
) =>
  (options?.client ?? client).post<BemasImportImportOrganizationsResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/bemas-import/organizations',
    ...options,
  });

export const backendApiProcessesFindAll = <ThrowOnError extends boolean = false>(
  options?: Options<ProcessesFindAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<ProcessesFindAllResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes',
    ...options,
  });

export const backendApiProcessesCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesCreateData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcessesCreateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiProcessesFindAllNotifications = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesFindAllNotificationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProcessesFindAllNotificationsResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/notifications',
    ...options,
  });

export const backendApiProcessesRemove = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ProcessesRemoveResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}',
    ...options,
  });

export const backendApiProcessesFindOne = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProcessesFindOneResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}',
    ...options,
  });

export const backendApiProcessesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesUpdateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<ProcessesUpdateResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiProcessesUpdateExternal = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesUpdateExternalData, ThrowOnError>,
) =>
  (options.client ?? client).patch<ProcessesUpdateExternalResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/external',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiProcessesUpdateStepDraft = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesUpdateStepDraftData, ThrowOnError>,
) =>
  (options.client ?? client).patch<ProcessesUpdateStepDraftResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/step-draft',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiProcessesUpdateStepExamination = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesUpdateStepExaminationData, ThrowOnError>,
) =>
  (options.client ?? client).patch<ProcessesUpdateStepExaminationResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/step-examination',
    ...options,
  });

export const backendApiProcessesUpdateStepDecision = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesUpdateStepDecisionData, ThrowOnError>,
) =>
  (options.client ?? client).patch<ProcessesUpdateStepDecisionResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/step-decision',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiProcessesUpdateStepExecution = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesUpdateStepExecutionData, ThrowOnError>,
) =>
  (options.client ?? client).patch<ProcessesUpdateStepExecutionResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/step-execution',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiProcessesFinalizeProcess = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesFinalizeProcessData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcessesFinalizeProcessResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/step-finalization',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiProcessesCancelProcess = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesCancelProcessData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcessesCancelProcessResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/cancel',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiProcessesGeneratePdf = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesGeneratePdfData, ThrowOnError>,
) =>
  (options.client ?? client).patch<ProcessesGeneratePdfResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/pdf',
    ...options,
  });

export const backendApiProcessesFindAllFiles = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesFindAllFilesData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProcessesFindAllFilesResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/files',
    ...options,
  });

export const backendApiProcessesUploadFile = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesUploadFileData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcessesUploadFileResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/files',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const backendApiProcessesRemoveFile = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesRemoveFileData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ProcessesRemoveFileResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/files/{fileId}',
    ...options,
  });

export const backendApiProcessesFindOneFile = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesFindOneFileData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProcessesFindOneFileResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/files/{fileId}',
    ...options,
  });

export const backendApiProcessesAddSign = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesAddSignData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcessesAddSignResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/addSign/{signId}',
    ...options,
  });

export const backendApiProcessesRemoveSign = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesRemoveSignData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ProcessesRemoveSignResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/removeSign/{signId}',
    ...options,
  });

export const backendApiProcessesCreateExamination = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesCreateExaminationData, ThrowOnError>,
) =>
  (options.client ?? client).post<ProcessesCreateExaminationResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/examinations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiProcessesRemoveExamination = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesRemoveExaminationData, ThrowOnError>,
) =>
  (options.client ?? client).delete<ProcessesRemoveExaminationResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/examinations/{examinationId}',
    ...options,
  });

export const backendApiProcessesUpdateExamination = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesUpdateExaminationData, ThrowOnError>,
) =>
  (options.client ?? client).patch<ProcessesUpdateExaminationResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/processes/{processId}/examinations/{examinationId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiProcessesFindOneExaminationPublic = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesFindOneExaminationPublicData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProcessesFindOneExaminationPublicResponses, unknown, ThrowOnError>({
    url: '/api/processes/{processId}/public-examinations/{examinationId}',
    ...options,
  });

export const backendApiProcessesUpdateExaminationPublic = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesUpdateExaminationPublicData, ThrowOnError>,
) =>
  (options.client ?? client).patch<ProcessesUpdateExaminationPublicResponses, unknown, ThrowOnError>({
    url: '/api/processes/{processId}/public-examinations/{examinationId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiProcessesFindOneExecutionPublic = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesFindOneExecutionPublicData, ThrowOnError>,
) =>
  (options.client ?? client).get<ProcessesFindOneExecutionPublicResponses, unknown, ThrowOnError>({
    url: '/api/processes/{processId}/public-execution',
    ...options,
  });

export const backendApiProcessesUpdateExecutionPublic = <ThrowOnError extends boolean = false>(
  options: Options<ProcessesUpdateExecutionPublicData, ThrowOnError>,
) =>
  (options.client ?? client).patch<ProcessesUpdateExecutionPublicResponses, unknown, ThrowOnError>({
    url: '/api/processes/{processId}/public-execution',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

export const backendApiSignImagesFindAll = <ThrowOnError extends boolean = false>(
  options: Options<SignImagesFindAllData, ThrowOnError>,
) =>
  (options.client ?? client).get<SignImagesFindAllResponses, unknown, ThrowOnError>({
    url: '/api/sign-images/{signId}/images',
    ...options,
  });

export const backendApiSignImagesUpload = <ThrowOnError extends boolean = false>(
  options: Options<SignImagesUploadData, ThrowOnError>,
) =>
  (options.client ?? client).post<SignImagesUploadResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/sign-images/{signId}/images',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const backendApiSignImagesRemove = <ThrowOnError extends boolean = false>(
  options: Options<SignImagesRemoveData, ThrowOnError>,
) =>
  (options.client ?? client).delete<SignImagesRemoveResponses, unknown, ThrowOnError>({
    url: '/api/sign-images/{signId}/images/{imageId}',
    ...options,
  });

export const backendApiSignImagesFindOne = <ThrowOnError extends boolean = false>(
  options: Options<SignImagesFindOneData, ThrowOnError>,
) =>
  (options.client ?? client).get<SignImagesFindOneResponses, unknown, ThrowOnError>({
    url: '/api/sign-images/{signId}/images/{imageId}',
    ...options,
  });

export const backendApiExternalSignsUpload = <ThrowOnError extends boolean = false>(
  options: Options<ExternalSignsUploadData, ThrowOnError>,
) =>
  (options.client ?? client).post<ExternalSignsUploadResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/external-signs/upload',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const backendApiExternalSignsImport = <ThrowOnError extends boolean = false>(
  options?: Options<ExternalSignsImportData, ThrowOnError>,
) =>
  (options?.client ?? client).post<ExternalSignsImportResponses, unknown, ThrowOnError>({
    security: [
      {
        in: 'cookie',
        name: 'vzk-bw',
        type: 'apiKey',
      },
    ],
    url: '/api/external-signs/import',
    ...options,
  });

export const backendApiOpenLrImport = <ThrowOnError extends boolean = false>(
  options?: Options<OpenLrImportData, ThrowOnError>,
) =>
  (options?.client ?? client).post<OpenLrImportResponses, unknown, ThrowOnError>({
    url: '/api/open-lr/import',
    ...options,
  });
